import React from 'react';
import { Route } from 'react-router-dom';

import DocumentTitle from '../generic/DocumentTitle';
import AddBrand from './AddBrand';
import ListBrands from './ListBrands';
import ShowBrand from './ShowBrand';
import UpdateBrand from './UpdateBrand';

function Routes() {
  return (
    <DocumentTitle title="Brands">
      <Route path="/brands" exact component={ListBrands} />
      <Route path="/brands/add" exact component={AddBrand} />
      <Route path="/brands/:id/show" exact component={ShowBrand} />
      <Route path="/brands/:id/edit" exact component={UpdateBrand} />
    </DocumentTitle>
  );
}

export default Routes;
